import React from "react"
import { createRoot } from "react-dom/client"
// import 'react-perfect-scrollbar/dist/css/styles.css';
import "./index.css"
import "./i18n"
import App from "./App"
import { Provider } from "react-redux"
import store from "./redux/store/index"
import AppTheme from "./AppTheme"
import * as Sentry from "@sentry/react"
import { useLocation, useNavigationType } from "react-router-dom"
import { createRoutesFromChildren, matchRoutes } from "react-router-dom"
import { useEffect } from "react"

if (process.env.NODE_ENV === "production" && process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    profilesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    sendDefaultPii: true,
    beforeSend(event) {
      if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
        return null
      }

      if (event.request?.headers) {
        delete event.request.headers["authorization"]
      }
      return event
    },
  })
}

const container = document.getElementById("root")
const root = createRoot(container as HTMLElement)

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <AppTheme>
        <App />
      </AppTheme>
    </Provider>
  </React.StrictMode>,
)
